import { IOffer, TCategoryExtended } from '../../../../types/offerData';

/**
 * @description Для коворкингов нет отдельной категории, поэтому пришлось маппить эту категорию ручками
 * @param {IOffer} offer
 * @return {TCategoryExtended}
 */
export function getExtendedCategory(offer: IOffer): TCategoryExtended {
  if (offer.coworkingOfferType) {
    return 'coworkingRent';
  }

  return offer.category;
}
